export default function WhatIsSection() {
  const items = [
    {
      icon: "ri-file-list-3-line",
      title: "Product Organization",
      desc: "BaseTao Spreadsheet helps you systematically organize every product you are interested in purchasing, with dedicated columns for item names, URLs, sizes, colors, and personal notes — making multi-item hauls effortless to manage.",
      image: "https://readdy.ai/api/search-image?query=Clean%20organized%20desk%20with%20neatly%20arranged%20product%20catalog%20cards%20and%20a%20notebook%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20photography%2C%20beige%20neutral%20palette%2C%20systematic%20organized%20composition%2C%20professional%20aesthetic&width=400&height=250&seq=whatis-org-v2&orientation=landscape",
    },
    {
      icon: "ri-price-tag-3-line",
      title: "Price Comparison",
      desc: "Track prices across different sellers and time periods using built-in formulas. The spreadsheet automatically calculates total costs including domestic shipping and service fees, giving you clear budget visibility before checkout.",
      image: "https://readdy.ai/api/search-image?query=Minimal%20workspace%20with%20calculator%20and%20price%20tags%20on%20warm%20cream%20desk%2C%20soft%20natural%20window%20light%2C%20editorial%20product%20photography%2C%20beige%20neutral%20tones%2C%20organized%20financial%20concept%2C%20clean%20professional%20composition&width=400&height=250&seq=whatis-price-v2&orientation=landscape",
    },
    {
      icon: "ri-store-2-line",
      title: "Seller Tracking",
      desc: "Record seller ratings, response times, and past transaction experiences directly in your spreadsheet. Build a personal database of trusted sellers for faster repeat purchases and fewer quality surprises.",
      image: "https://readdy.ai/api/search-image?query=Warm%20desk%20setup%20with%20a%20laptop%20showing%20store%20ratings%20and%20seller%20profiles%2C%20soft%20natural%20lighting%2C%20editorial%20photography%2C%20cream%20beige%20palette%2C%20organized%20professional%20workspace%2C%20trustworthy%20business%20concept&width=400&height=250&seq=whatis-seller-v2&orientation=landscape",
    },
    {
      icon: "ri-archive-line",
      title: "Warehouse Management",
      desc: "Monitor which items have arrived at the BaseTao warehouse, track QC photo status, and plan parcel consolidation. The spreadsheet serves as your centralized command center for warehouse operations.",
      image: "https://readdy.ai/api/search-image?query=Organized%20small%20storage%20boxes%20on%20warm%20cream%20shelving%2C%20soft%20natural%20lighting%2C%20clean%20minimalist%20warehouse%20concept%2C%20beige%20neutral%20palette%2C%20professional%20logistics%20photography%2C%20efficient%20organized%20atmosphere&width=400&height=250&seq=whatis-warehouse-v2&orientation=landscape",
    },
    {
      icon: "ri-ship-line",
      title: "Order Tracking",
      desc: "Log tracking numbers, shipping methods, and estimated delivery dates in one place. Cross-reference actual delivery times with estimates to refine your shipping strategy for future hauls.",
      image: "https://readdy.ai/api/search-image?query=Clean%20desk%20with%20shipping%20labels%20and%20tracking%20documents%20on%20warm%20cream%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20photography%2C%20beige%20neutral%20palette%2C%20organized%20logistics%20concept%2C%20professional%20commercial%20aesthetic&width=400&height=250&seq=whatis-tracking-v2&orientation=landscape",
    },
    {
      icon: "ri-bar-chart-grouped-line",
      title: "Community Data Integration",
      desc: "Leverage community-sourced spreadsheet templates and shared data to benchmark prices, discover trending items, and access curated seller lists — accelerating your shopping research dramatically.",
      image: "https://readdy.ai/api/search-image?query=Collaborative%20workspace%20with%20laptop%20showing%20data%20charts%20and%20community%20graphs%2C%20warm%20cream%20desk%2C%20soft%20natural%20lighting%2C%20editorial%20photography%2C%20beige%20neutral%20palette%2C%20modern%20professional%20aesthetic%2C%20connected%20networked%20concept&width=400&height=250&seq=whatis-community-v2&orientation=landscape",
    },
  ];

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-10">
          What Is <span className="text-primary-600">BaseTao Spreadsheet</span>?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((item) => (
            <div
              key={item.title}
              className="flex flex-col rounded-xl bg-background-100 border border-background-200/60 overflow-hidden hover:border-primary-200/60 transition-all"
            >
              <div className="h-36 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  loading="lazy"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex gap-3 p-5">
                <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center shrink-0">
                  <i className={`${item.icon} text-primary-500 text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-heading text-base text-foreground-900 mb-1">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}